<template>
  <div v-if="showWarning || showDeadlineWarning" class="subscription-warning">
    <!-- Critical warning: payment overdue -->
    <a-alert
      v-if="showWarning"
      message="Абонемент не оплачен"
      type="error"
      show-icon
    >
      <template #icon>
        <ExclamationCircleOutlined />
      </template>
      <template #description>
        <div>
          Для участия в событиях необходимо оплатить абонемент
          <a-button 
            size="large" 
            type="primary" 
            block 
            class="pay-btn"
            @click="goToSubscription"
          >
            Оплатить
        </a-button>
        </div>
      </template>
    </a-alert>

    <!-- Warning: deadline approaching -->
    <a-alert
      v-else-if="showDeadlineWarning"
      :message="deadlineWarningMessage"
      type="warning"
      show-icon
    >
      <template #icon>
        <ClockCircleOutlined />
      </template>
      <template #description>
        <div>
          {{ deadlineWarningDescription }}
          <a-button 
            size="large" 
            type="primary" 
            block 
            class="pay-btn"
            @click="goToSubscription"
          >
            Оплатить сейчас
        </a-button>
        </div>
      </template>
    </a-alert>
  </div>
</template>

<script>
import { ExclamationCircleOutlined, ClockCircleOutlined } from '@ant-design/icons-vue';
import { Alert, Button } from 'ant-design-vue';

export default {
  name: 'SubscriptionWarning',
  components: {
    ExclamationCircleOutlined,
    ClockCircleOutlined,
    'a-alert': Alert,
    'a-button': Button
  },
  props: {
    subscriptionStatus: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    showWarning() {
      const result = this.subscriptionStatus.some(status => status.is_blocked);
      console.log('🚨 SubscriptionWarning.showWarning:', {
        subscriptionStatus: this.subscriptionStatus.map(s => ({
          team: s.team_name,
          is_blocked: s.is_blocked,
          is_deadline_approaching: s.is_deadline_approaching,
          payment_status: s.payment_status,
          days_until_deadline: s.days_until_deadline
        })),
        result
      });
      return result;
    },
    showDeadlineWarning() {
      // Don't show deadline warning if already blocked
      if (this.showWarning) return false;
      const result = this.subscriptionStatus.some(status => status.is_deadline_approaching);
      console.log('⏰ SubscriptionWarning.showDeadlineWarning:', {
        result,
        subscriptionStatus: this.subscriptionStatus.map(s => ({
          team: s.team_name,
          is_deadline_approaching: s.is_deadline_approaching
        }))
      });
      return result;
    },
    deadlineTeam() {
      const team = this.subscriptionStatus.find(status => status.is_deadline_approaching);
      return team || null;
    },
    deadlineWarningMessage() {
      if (!this.deadlineTeam) return '';
      const days = this.deadlineTeam.days_until_deadline;
      if (days === 0) {
        return 'Сегодня последний день оплаты абонемента!';
      } else if (days === 1) {
        return 'Завтра последний день оплаты абонемента!';
      } else if (days === 2) {
        return 'Скоро истекает срок оплаты абонемента';
      }
      return 'Приближается срок оплаты абонемента';
    },
    deadlineWarningDescription() {
      if (!this.deadlineTeam) return '';
      const days = this.deadlineTeam.days_until_deadline;
      const deadlineDay = this.deadlineTeam.payment_deadline_day;
      const amount = this.deadlineTeam.subscription_amount;
      
      if (days === 0) {
        return `Сегодня (${deadlineDay} числа) последний день для оплаты абонемента (${amount} руб.). Оплатите сейчас, чтобы избежать блокировки участия в событиях!`;
      } else if (days === 1) {
        return `Завтра (${deadlineDay} числа) последний день для оплаты абонемента (${amount} руб.). Оплатите сегодня, чтобы избежать блокировки участия в событиях.`;
      } else if (days === 2) {
        return `Через ${days} дня (${deadlineDay} числа) истекает срок оплаты абонемента (${amount} руб.). Рекомендуем оплатить заранее.`;
      }
      return `Срок оплаты абонемента: ${deadlineDay} число каждого месяца. Сумма: ${amount} руб.`;
    }
  },
  methods: {
    goToSubscription() {
      this.$emit('go-to-subscription');
    }
  }
};
</script>

<style scoped>
.subscription-warning {
  margin-bottom: 16px;
}

.subscription-warning .ant-alert {
  border-radius: 8px;
}

.pay-btn {
  margin-top: 20px;
}
</style> 